import React from 'react';
import type { BioRenderableCandidate } from '@axiom/validation';
import { Education as EducationConst } from '@axiom/const';

import { Paragraph } from '../../content/Paragraph/Paragraph';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { Gutter } from '../../layout/Gutter/Gutter';
import { EducationUtils } from '../../../utils/education-utils';

export type TalentEducationTypes = {
  candidate: BioRenderableCandidate;
};

export const TalentEducation = ({ candidate }: TalentEducationTypes) => (
  <>
    {candidate.degrees?.length === 0 && (
      <Paragraph name="NO_EDUCATION">--</Paragraph>
    )}
    {Array.isArray(candidate.degrees) &&
      EducationUtils.sortDisplay(candidate.degrees).map(
        ({ institution, degree, yearAwarded, areaOfStudy }, index) => (
          <div
            data-test="EDUCATION_DEGREE"
            key={`${yearAwarded}_${institution}_${degree}_${areaOfStudy?.name}`}
          >
            <ParagraphHeader name="DEGREE_INSTITUTION">
              {institution}
            </ParagraphHeader>

            <Paragraph name="EDUCATION">
              {[
                degree ? EducationConst.DEGREES[degree] : '',
                areaOfStudy?.name,
                yearAwarded,
              ]
                .filter(Boolean)
                .join(', ')}
            </Paragraph>
            {candidate.degrees && index < candidate.degrees.length - 1 ? (
              <Gutter bottom="16px" />
            ) : null}
          </div>
        )
      )}
  </>
);
